'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_CommentNode(initialText) {
  this.zb = null;
  this.zc = null;
  this.zb = $j_java$002elang$002e$002dObject.$m_s_None$();
  this.zc = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_DomApi$().Tk(initialText);
}
export { $c_Lcom_raquo_laminar_nodes_CommentNode as $c_Lcom_raquo_laminar_nodes_CommentNode };
$p = $c_Lcom_raquo_laminar_nodes_CommentNode.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_CommentNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_CommentNode() {
}
export { $h_Lcom_raquo_laminar_nodes_CommentNode as $h_Lcom_raquo_laminar_nodes_CommentNode };
$h_Lcom_raquo_laminar_nodes_CommentNode.prototype = $p;
$p.Bh = (function() {
  return this.zb;
});
$p.lf = (function(maybeNextParent) {
  this.zb = maybeNextParent;
});
$p.lq = (function(maybeNextParent) {
});
$p.dL = (function(parentNode) {
  $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().qP(parentNode, this, (void 0));
});
$p.aV = (function() {
  return this.zc;
});
var $d_Lcom_raquo_laminar_nodes_CommentNode = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_nodes_CommentNode, "com.raquo.laminar.nodes.CommentNode", ({
  iH: 1,
  bM: 1,
  ab: 1,
  c7: 1
}));
export { $d_Lcom_raquo_laminar_nodes_CommentNode as $d_Lcom_raquo_laminar_nodes_CommentNode };
